import script from "./BarreRecherche.vue?vue&type=script&setup=true&lang=js"
export * from "./BarreRecherche.vue?vue&type=script&setup=true&lang=js"

import "./BarreRecherche.vue?vue&type=style&index=0&id=10679ffd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10679ffd"]])

export default __exports__